<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <CIcon
        class="c-sidebar-brand-full icon-displacement"
        name="logo"
        :icon="logo"
        size="custom-size"
        :height="35"
        viewBox="-50 0 300 35"
      />
      <!-- <el-button class="buttonGrey" @click="$store.commit('toggleUnfoldable')">
        <CIcon icon="cilDoubleLeft" />
      </el-button> -->
    </CSidebarBrand>

    <AppSidebarNav />
  </CSidebar>
</template>

<script>
import { logo } from '@/assets/brand/logo'
import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'

export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
  },
  setup() {
    const store = useStore()
    return {
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
      logo,
    }
  },
}
</script>

<style scoped>
.buttonGrey {
  background-color: transparent;
  padding: 0px 0px 0px 0px;
  border-color: transparent;
}

.nav-cheerful {
  color: #cdd0d6;
  height: 50px;
  justify-content: left;
  padding-left: 20px;
  padding-top: 20px;
}
</style>
